(function () {
  const sectionName = 'editorial';

  if (sectionName in Shopify.theme.sections.registered) {
    const sections = document.querySelectorAll(`[data-section-type=${sectionName}]`);

    sections.forEach((section, index) => {
      if (index !== 0) {
        const linkTag = section.querySelector('link');
        const scriptTag = section.querySelector('script');

        linkTag.remove();
        scriptTag.remove();
      }
    });
  } else {
    const iconsArray = document.querySelectorAll('.editorial__itemListIcon');

    function toggleQuickView(target) {
      const currentList = target.closest('.editorial__itemList');

      currentList.classList.toggle('editorial__itemList--active');
    }

    iconsArray.forEach((icon) => {
      icon.addEventListener('click', (e) => {
        toggleQuickView(e.currentTarget);
      });
    });
  }

  Shopify.theme.sections.register(sectionName);
}());
